/**
 * Workspace enviado ao socket (newUser / users), alinhado ao legado Cockpit/Xpro.
 * Prioriza o slug do tenant em localStorage; fallback para o host atual.
 */
export function getSocketWorkspace() {
  if (typeof window === "undefined") return "";
  try {
    const company = localStorage.getItem("company");
    if (company) return `${company}.xpro.me`;
  } catch {
    /* ignore */
  }
  return window.location.host || "";
}
